import axios from '@axios'

export default {
  namespaced: true,
  actions: {

    listRfids(ctx, params) {
      return new Promise((resolve, reject) => {
        axios.get('rfids', {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    createRfid(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.post('rfids', form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    fetchRfid(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.get(`rfids/${id}/edit`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    updateRfid(ctx, { id, form }) {
      return new Promise((resolve, reject) => {
        axios.put(`rfids/${id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


  },
}
